<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <h1>{{ $STR.tituloCentroAyuda }}</h1>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 titulo-contenedor align-content-center flex-wrap d-flex" v-if="$store.state.login">
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0" >
        <v-btn color="primary" elevation="2" medium rounded x-large @click="onClickAgregarMaterial()">
          {{ $STR.btnAgregarMaterial }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 titulo-contenedor-primary">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <h2>{{ $STR.subtituloCentroAyuda }}</h2>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0">
      <v-col lg="4" md="6" sm="12" class="pa-4 ma-0" v-for="(item, index) in aProductos" :key="index">
        <v-card align="center" justify="space-around" elevation="8" shaped>
          <v-card-title class="d-flex justify-center subtitulo-producto">
            {{ item.Producto }}
          </v-card-title>
          <v-card-actions class="d-flex justify-center">
            <v-btn color="primary" rounded @click="onClickProducto(item)">
              {{ $STR.btnVer }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";
// import { mixFunciones } from "@/mixins/funciones.js";

export default {
  name: "DashboardAyuda",
  // mixins: [mixFunciones],
  mounted() {
    // realizamos validaciones antes de guardar en localstorage
    const { tecnologia, codigo, idProducto } = this.$route.query;
    
    sessionStorage.tecnologia = tecnologia || 2;
    if(codigo)     sessionStorage.codigo = this.$route.query.codigo;
    if(idProducto) sessionStorage.producto = this.$route.query.idProducto;
    this.onLoadData();
  },
  data() {
    return {
      cargando: false,
      aProductos: [],
      sToken: this.$store.state.token
    };
  },
  methods: {
    onLoadData() {
      this.cargando = true;
      axiosServices.getConfiguration(`/base_conocimientos/productos`, false, `app=dashboard-vue&token=${this.sToken}`)
        .then((aResponse) => {
          this.aProductos = aResponse.aData;
          this.cargando = false;
        });
    },
    onClickProducto(item) {
      let path = `/Inicio/centro-de-ayuda/dashboard/producto/`
      Object.keys(item).forEach((oItem) => {
        if(typeof item[oItem] === 'undefined' ) return;
        switch(oItem) {
          case 'idBC_Productos':
            path += `${item.idBC_Productos}?&tecnologia=${sessionStorage.tecnologia}&perfil=${sessionStorage.perfil}&usuario=${sessionStorage.usuario}&codigo=${sessionStorage.codigo}`
            // almacenamos en sessionStorage el codigo del producto
            sessionStorage.setItem('producto', item.idBC_Productos)
            break;
        }
      })
      this.$router.push({ path: path })
    },
    onClickAgregarMaterial() {
      this.$router.push({ name: "NuevaPregunta" });
    },
  },
};
</script>
